module.exports = __webpack_public_path__ + "static/media/calendario-2023-ii.38a4a2cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendario-2023-ii.jpg
// module id = 834
// module chunks = 0